import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../services/users.service';
import { Candidates } from '../../models/candidates.model';
import { Companies } from '../../models/companies.model';
import { Admins } from '../../models/admins.model';
import { FunctionsService } from '../../services/functions.service';
import { Consultants } from '../../models/consultants.model';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import Swal from 'sweetalert2';
declare var headerScroll: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isLoading: boolean = false;
  newsletterForm: FormGroup = new FormGroup({
    email: new FormControl('')
  });


  // userIsConnected: boolean = false;
  userName: string = "Non connecté";
  userType: string = "";
  menuIsOpen: boolean = false;
  userIsConnected = this.usersService.isAuth();

  constructor(private formBuilder: FormBuilder, private httpService: HttpService, private userService: UsersService, private usersService: UsersService, public functionsService: FunctionsService) { }

  ngOnInit(): void {
    // console.log(localStorage.getItem('currentCandidate'));
    // new headerScroll();

    if (localStorage.getItem('currentCandidate') != null) {

      const candidates = new Candidates(this.usersService.getCurrentUser());
      this.userName = candidates.getName();
      this.userType = "candidat";
    } else if (localStorage.getItem('currentConsultant') != null) {
      const currentConsultant = new Consultants(this.usersService.getCurrentUser());
      this.userName = currentConsultant.getName();
      this.userIsConnected = true;
      this.userType = "consultant";
    } else if (localStorage.getItem('currentCompany') != null) {
      const currentCompany = new Companies(this.usersService.getCurrentUser());
      this.userName = currentCompany.getAcronym();
      this.userIsConnected = true;
      this.userType = "entreprise";
    } else if (localStorage.getItem('currentAdmin') != undefined) {
      const data: any = localStorage.getItem('currentAdmin');
      const currentAdmin = new Admins(JSON.parse(data));
      this.userName = currentAdmin.getName();
      this.userIsConnected = true;
      this.userType = "admin";
    }
  }
  initForm() {
    this.newsletterForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmitForm() {
    this.isLoading = true;
    this.httpService.subscribeNewsletter(this.newsletterForm.value).subscribe(
      (response: any) => {
        if (response.status == "success") {
          Swal.fire({
            icon: 'success',
            title: 'Excellent!',
            text: 'Vous serais désormains informé des nouveautés sur nos produits & services.',
          });
          this.newsletterForm.reset();
        }
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
        if (error.error.message && error.error.message == 'EMAIL_ALREADY_EXISTE') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vous avez déjà souscrit à la newsletter.',
          })
        } else {
          this.isLoading = false;
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  logout() {
    localStorage.removeItem('currentCandidate');
    localStorage.removeItem('currentConsultant');
    localStorage.removeItem('currentCompany');
    localStorage.removeItem('currentAdmin');

    location.reload();
  }

  openCloseMenu() {
    let mobile_nav: any = document.getElementById('mobile-nav');

    if (window.getComputedStyle(mobile_nav).display === "none") {
      mobile_nav.style.display = "block";
      this.menuIsOpen = true;
    } else {
      mobile_nav.style.display = "none";
      this.menuIsOpen = false;
    }
  }

  showHideSubMenu(elementID: any) {
    let element: any = document.getElementById(elementID);

    if (element.style.display == "block") {
      element.style.display = "none";
    } else if (element.style.display = "none") {
      element.style.display = "block";
    }
  }

}
